<template>
  <Modal
    v-model="_value"
    width="800"
    ok-text="修改"
    cancel-text=""
    @on-ok="onOk"
    @on-visible-change="visibleChange"
    title="两客一危一重客户参数详细信息">
    <Form ref="setupRegistration" autoComplete="on" class="card-box login-form" :label-width="120">
      <Form-item label="客户名称">
        <Input v-model="gdDlysjgClientParam.clientName"></Input>
      </Form-item>
      <Form-item label="授权码">
        <Input v-model="gdDlysjgClientParam.authorizationCode"></Input>
      </Form-item>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  export default {
    name: 'gddlysjgclientparamdetailmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data () {
      return {

        loading:false,

        gdDlysjgClientParam: {
          id:null,
          clientName: null,
          authorizationCode:null
        }
      }
    },
    methods: {
      ...mapActions([
        'GdDlysjgClientParamServ_ModifyObj'
      ]),
      onOk () {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认修改</p>',
          onOk: () => {
            store.dispatch('GdDlysjgClientParamServ_ModifyObj', {
              params: this.gdDlysjgClientParam
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.loading = true
          store.dispatch('GdDlysjgClientParamServ_GetDetail', {
            params: {id: this._initValue}
          }).then(() => {
            this.gdDlysjgClientParam = store.getters.get_GdDlysjgClientParam_GetDetailResult
            this.loading = false
          }).catch(err => {
            this.$Message.error(err)
            this.loading = false
          })
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
